import { ContentStoreCategoriesService } from 'src/services/Categories';

export const deleteCategory = (
    { accessToken, id }: App.Category.DeleteMutationVariables,
): Promise<void> => ContentStoreCategoriesService.deleteCategory(accessToken, id);
